import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { IntersectionObserverDirective } from '../../../core/directives/animate-on-visible.directive';

@Component({
  selector: 'app-pricing',
  imports: [RouterLink, IntersectionObserverDirective],
  templateUrl: './pricing.html',
  styleUrl: './pricing.scss',
})
export class Pricing {

}
